export default () =>
	Component(
		$context => $context.select('.shop-page'),
		$page => {
			function initEventListeners() {
				$(document).on('shop_sort_products replace_products', (e, html) => {
					const $html = $(html);
					$page.find('.products__items').html($html.find('.products__items').html());

					$(document).trigger('update_products');
				});
			}

			initEventListeners();
		}
	);
